define.alias("ember-in-viewport/modifiers/in-viewport", "calendar/modifiers/in-viewport");